import { render, staticRenderFns } from "./Mixed.vue?vue&type=template&id=510c740d&scoped=true"
import script from "./Mixed.vue?vue&type=script&lang=js"
export * from "./Mixed.vue?vue&type=script&lang=js"
import style0 from "./Mixed.vue?vue&type=style&index=0&id=510c740d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c740d",
  null
  
)

export default component.exports